"use strict";
const CONNECTION = 'connection';
exports.CONNECTION_CHANGED = CONNECTION + '/changed';
const AUTH = 'auth';
exports.ATTEMPT_LOGIN = AUTH + '/attempt-login';
exports.ACCOUNT_EXISTS = AUTH + '/account-exists';
exports.LOGIN_SUCCESS = AUTH + '/login-success';
exports.LOGOUT = AUTH + '/logout';
const TASKS = 'tasks';
exports.LISTEN_TO_TASKS = TASKS + '/listen';
exports.STOP_LISTENING_TO_TASKS = TASKS + '/stop-listening';
exports.TASK_ADDED = TASKS + '/added';
exports.TASK_CHANGED = TASKS + '/changed';
exports.TASK_REMOVED = TASKS + '/removed';
exports.SAVE_TASK_ERROR = TASKS + '/save-error';
exports.START_TASK_ERROR = TASKS + '/start-error';
exports.STOP_TASK_ERROR = TASKS + '/stop-error';
exports.PAUSE_TASK_ERROR = TASKS + '/pause-error';
exports.DELETE_TASK_ERROR = TASKS + '/delete-error';
const SESSIONS = 'sessions';
exports.LISTEN_TO_SESSIONS = SESSIONS + '/listen';
exports.STOP_LISTENING_TO_SESSIONS = SESSIONS + '/stop-listening';
exports.SESSION_ADDED = SESSIONS + '/added';
exports.SESSION_CHANGED = SESSIONS + '/changed';
exports.SESSION_REMOVED = SESSIONS + '/removed';
const SNACKBAR = 'snackbar';
exports.DISMISS_SNACKBAR_MESSAGE = SNACKBAR + '/dismiss-message';
exports.POST_SNACKBAR_MESSAGE = SNACKBAR + '/post-message';
exports.POST_SNACKBAR_APP_UPDATE_AVAILABLE = SNACKBAR + '/app-update-available';



/** WEBPACK FOOTER **
 ** ./src/actionTypes.ts
 **/